export const toolbarOptions = [
  ['bold', 'italic', 'underline', { header: 2 }, { header: 3 }, 'link', 'blockquote', 'clean']
];
